import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeDecimalsCurrency',
    standalone: false
})
export class RemoveDecimalsCurrencyPipe implements PipeTransform {
	transform(value: any): string {
		// Converter o valor para número
		 const numericValue = Number(value ?? 0);
		// Verificar se é um número válido
		if (isNaN(numericValue)) {
			return '';
		}

		// Arredondar para a parte inteira
		const intValue = Math.floor(numericValue);

		// Formatar como moeda colombiana (COP)
		const formattedValue = new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(intValue);

		return formattedValue;
	}
}
